import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const RISKY_AREA = {
  YES: 'yes',
  NO: 'no',
} as const;

export const RISKY_AREA_NAME = 'risky_area';

export const RadioGroupRiskyArea = () => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={RISKY_AREA_NAME}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy Twoja szkoda miała miejsce na terenie jednego z tych powiatów? Bydgoski, Inowrocławski, Mogileński, Nakielski, Świecki, Szubiński, Tucholski, Żniński'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout="horizontal"
              data-testid="radio-group-risky-area"
            >
              <RadioItem
                value={RISKY_AREA.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-risky-area-yes"
              />
              <RadioItem
                value={RISKY_AREA.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-risky-area-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
